import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { AgeRangesDataService, AgeRangesColumnsService } from '../../../services';
import { AgeRange, AgeRangesResult } from '../../../interfaces';
import { DialogFilerComponent } from '../../filer/filer.component';

@Component({
  selector: 'app-age-range-form',
  templateUrl: './age-range-form.component.html',
  styleUrls: ['./age-range-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class AgeRangeFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public ageRange: AgeRange = {};
  public ageRangeForm: FormGroup = new FormGroup({});
  public ageRanges: AgeRange[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;

  private filerDialog: DynamicDialogRef = new DynamicDialogRef();

  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private ageRangesDataService: AgeRangesDataService,
    public ageRangesColumnsService: AgeRangesColumnsService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'AgeRangeFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Age Range - Edit');
        this.getAgeRange(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.ageRange !== 'undefined') {
      this.ageRange = this.dynamicDialogConfig.data.ageRange;
    }
    if (typeof this.ageRange.id === 'undefined' || this.ageRange.id === null) {
      this.ageRange.id = null;
      this.ageRange.isPublished = false;
    }
    this.getAgeRanges();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'AgeRangeFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'AgeRangeFormComponent');
  }

  getAgeRange(id: number): void {
    this.isLoading = true;
    this.ageRangesDataService.getAgeRange(id).subscribe((response: AgeRange|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.ageRange = response;
        this.prepareFrom();
      }
    });
  }

  getAgeRanges(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.ageRanges !== 'undefined' && this.dynamicDialogConfig.data.ageRanges.length > 0) {
      this.ageRanges = this.dynamicDialogConfig.data.ageRanges;
      return;
    }
    this.ageRangesDataService.getAgeRanges(this.parameters).subscribe((response: AgeRangesResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.ageRanges = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.ageRangeForm = new FormGroup({
      id: new FormControl(this.ageRange.id, []),
      name: new FormControl(this.ageRange.name, [Validators.required, ]),
      nameAr: new FormControl(this.ageRange.nameAr, []),
      nameFr: new FormControl(this.ageRange.nameFr, []),
      minAge: new FormControl(this.ageRange.minAge, [Validators.required, ]),
      maxAge: new FormControl(this.ageRange.maxAge, [Validators.required, ]),
      icon: new FormControl(this.ageRange.icon, []),
      isPublished: new FormControl(this.ageRange.isPublished, [Validators.required, ]),
    });
  }

  list() {
    this.router.navigate(['/age-ranges']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.ageRangeForm.controls).forEach((field: any) => {
        const control = this.ageRangeForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.ageRangeForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.ageRange = this.ageRangeForm.value;
    this.disableSubmit = true;
    console.log('ageRange', this.ageRange);
    if (typeof this.ageRange.id !== 'undefined' && this.ageRange.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.ageRangesDataService.updateAgeRange(this.ageRange).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('AGERANGEUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('AGERANGENOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.ageRangesDataService.addAgeRange(this.ageRange).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('AGERANGECREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('AGERANGENOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

  openFilerDialog(field: string): void {
    let url = '';
    const control = this.ageRangeForm.get(field);
    if (control !== null) {
      url = control.value;
    }
    this.filerDialog = this.dialogService.open(DialogFilerComponent, {
      header: '', // this.translate.instant('FILEMANAGER'),
      width: '90%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1500,
      data: {
        path: 'age-ranges',
        field: field,
        url: url,
      },
    });
    this.filerDialog.onClose.subscribe((response: any) => {
      if (response && response.selected) {
        const control = this.ageRangeForm.get(field);
        if (control !== null) {
          control.setValue(response.selected.webPath);
        }
      }
    });
  }

}

@Component({
  selector: 'app-age-range-form',
  templateUrl: './age-range-form.component.html',
  styleUrls: ['./age-range-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogAgeRangeFormComponent extends AgeRangeFormComponent {
}

